import { createTheme } from '@mui/material/styles';
// Extend MUI variants for JS
const customVariants = {
  h7: {
    fontSize: '19px',
    fontWeight: 400,
    lineHeight: '28px',
    fontFamily: 'Poppins',
  },
  body3: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
  },
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: "#ffffff",
      light: "#FAFAFA",
    },
    red: {
      main: "#DC143C",
      light: "#FAEAEE",
      lighter: "#FF809A",
    },

    grey: {
      100: "#4A4A4A",
      200: "#2B2626",
      300: "#606060",
      400: "#6E6E6E",
      500: "#4E4E4E",
      600: "#00000099"

    },
    background: {
      default: '#FAFAFA',
      paper: '#ffffff',
    },
    text: {
      primary: '#0D0D0D',
      secondary: '#000000',

    },

  },
  typography: {
    h1: {
      fontSize: '2.3rem',
      fontWeight: 700,
      lineHeight: "3rem",
      [createTheme().breakpoints.down('md')]: {
        fontSize: '2rem',
        lineHeight: '2.6rem',
      },
      [createTheme().breakpoints.down('sm')]: {
        fontSize: '1.6rem',
        lineHeight: '2rem',
      },
    },
    h2: {
      fontSize: "2.2rem",
      fontWeight: 700,
      lineHeight: "3.2rem",
      [createTheme().breakpoints.down('md')]: {
        fontSize: '1.9rem',
        lineHeight: '2.6rem',
      },
      [createTheme().breakpoints.down('sm')]: {
        fontSize: '1.4rem',
        lineHeight: '1.8rem',
      },
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 700,
      lineHeight: "3rem",
      [createTheme().breakpoints.down('md')]: {
        fontSize: '1.6rem',
        lineHeight: '2.4rem',
      },
      [createTheme().breakpoints.down('sm')]: {
        fontSize: '1.3rem',
        lineHeight: '1.7rem',
      },

    },
    h4: {
      fontSize: '1.8rem',
      fontWeight: 400,
      lineHeight: "3rem",
      [createTheme().breakpoints.down('md')]: {
        fontSize: '1.6rem',
        lineHeight: '2.5rem',
      },
      [createTheme().breakpoints.down('sm')]: {
        fontSize: '1.3rem',
        lineHeight: '1.8rem',
      },
    },
    h5: {
      fontSize: '1.6rem',
      fontWeight: 400,
      lineHeight: "2.3rem",
      [createTheme().breakpoints.down('md')]: {
        fontSize: '1.2rem',
        lineHeight: '2rem',
      },
      [createTheme().breakpoints.down('sm')]: {
        fontSize: '1.1rem',
        lineHeight: '1.5rem',
      },
    },
    h6: {
      fontSize: '1.4rem',
      fontWeight: 400,
      lineHeight: "2rem",
      fontFamily: "Poppins",
      [createTheme().breakpoints.down('md')]: {
        fontSize: '1.2rem',
        lineHeight: '2rem',
      },
      [createTheme().breakpoints.down('sm')]: {
        fontSize: '1.1rem',
        lineHeight: '1.5rem',
      },
    },
  
    body1: {
      fontSize: "1.1rem",
      fontWeight: 400,
      lineHeight: "1.5rem"
    

    },
    body2: {
      fontSize: "0.9rem",
      fontWeight: 400,
      lineHeight: "1.3rem",
     
    },
    subtitle1: {
      fontSize: '1.3rem',
      fontWeight: 400,
      lineHeight: "1.6rem",
      fontFamily: "Poppins",
      [createTheme().breakpoints.down('md')]: {
        fontSize: '1.2rem',
        lineHeight: '1.6rem',
      },
      [createTheme().breakpoints.down('sm')]: {
        fontSize: '1.1rem',
        lineHeight: '1.5rem',
      },
    }
   
  },

  shape: {
    borderRadius: 8,
  },
  components: {
    // MuiTypography: {
    //   defaultProps: {
    //     color: "text.primary",
    //     fontSize: "body2",
    //     fontFamily: "Sora",

    //   },
    // },

    MuiTypography: {
      defaultProps: {
        color: "text.primary",
        fontFamily: "Sora",
      },

      variants: [
        {
          props: { variant: "h7" },
          style: {
            fontSize: "19px",
            fontWeight: 400,
            lineHeight: "28px",
            fontFamily: "Sora",
          }
        },
        {
          props: { variant: "body3" },
          style: {
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "16px",
            fontFamily: "Sora",
          }
        }
      ],
    },

    MuiButton: {
      defaultProps: {
        disableElevation: true,
        sx: {
          borderRadius: "12px",
          textTransform: "capitalize",
          fontSize: "20px",
          fontWeight: 500,
          lineHeight: "30px",
          // padding: "40px",

          "&.MuiButton-outlined": {
            fontSize: "16px",
            fontWeight: 400,
            color: "red.main",
            backgroundColor: "transparent",
            border: "1px solid #DC143C",
            boxShadow: "0px 4px 4px 0px #00000040",
            // height: "45px"
            lineHeight: "30.36px",
          },

          "&.MuiButton-contained": {
            // minHeight: "40px",
            fontSize: { xs: "14px", md: "20px" },
            fontWeight: "400",
            lineHeight: "35.36px",
            color: "primary.main",
            backgroundColor: "red.main",
            '&.Mui-disabled': {
              backgroundColor: "#FF809A",
            },
          },

          "&.MuiButton-text, &.MuiButton-gost": {
            // minWidth: "400px",
            fontSize: { xs: "14px", md: "20px" },
            fontWeight: 500,
            lineHeight: "35.36px",
            borderRadius: "12px",
            p: "0px 20px",
          },
          "&.MuiButton-text": {
            color: "primary.main",
            backgroundColor: "red.main",
          },

          "&.MuiButton-gost": {
            color: "red.main",
            backgroundColor: "primary.main",
          },

        },
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },

    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 0,
          "&:last-child": {
            paddingBottom: 0,
          },
          boxShadow: "none"
        },
      }
    },

    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-container--top [role=row], & .MuiDataGrid-container--bottom [role=row]": {
            backgroundColor: "#EDEDED", // Apply Royal Blue background
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: "14px",
            fontWeight: "400 !important",
            color: "#000000",
          },
          "& .MuiDataGrid-columnSeparator--resizable": {
            display: "none", // Hide column separator
          },
          "& .MuiDataGrid-sortIcon, & .MuiDataGrid-filterIcon , & .MuiDataGrid-menuIconButton": {
            color: "#fff", // Set icon color to white
          },
          "& .MuiDataGrid-withBorderColor": {
            borderColor: "#B3B3B3 !important", // Change ALL border colors except header
          },
          // "& .MuiDataGrid-footerContainer": {
          //   display: "none !important", // Hides the last pagination element
          // },
        },
      },
      defaultProps: {
        pageSizeOptions: [10, 25, 50, 100],
        initialState: {
          pagination: {
            paginationModel: { pageSize: 10, page: 0 },
          },
        },
        checkboxSelection: false,
        sx(theme) {
          return {
            ".MuiDataGrid-columnHeader": {
              borderRight: "0.5px solid #B3B3B3", // ✅ Adds a right-side border to headers and cells
            },
            "& .MuiDataGrid-columnHeader:last-child, & .MuiDataGrid-cell:last-child": {
              borderRight: "none !important",
            },
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal", // ✅ Allow text wrapping
              wordWrap: "break-word",
              overflowWrap: "break-word",
              display: "flex",
              alignItems: "center", // ✅ Center align vertically
              justifyContent: "start", // ✅ Center align horizontally
              minHeight: "auto", // ✅ Auto height
              textAlign: "start", // ✅ Ensure text is centered inside the cell
              borderRight: "0.5px solid #B3B3B3",
            },
            "& .MuiDataGrid-row": {
              minHeight: "auto !important", // ✅ Ensure rows expand
              height: "auto !important",
            },
            "& .MuiDataGrid-virtualScrollerContent": {
              minHeight: "auto !important", // ✅ Make sure content flows correctly
            }
          };
        },
      },
    },


    // MuiDataGrid: {
    //   styleOverrides: {
    //     root: {
    //       border: "none",
    //       boxShadow: "none",
    //       backgroundColor: "transparent",

    //       "& .MuiPaper-root": {
    //         boxShadow: "none !important",
    //         backgroundColor: "transparent",
    //       },

    //       "& .MuiDataGrid-main": {
    //         boxShadow: "none !important",
    //       },

    //       "& .MuiDataGrid-columnHeaders": {
    //         border: "none",
    //         borderBottom: "none",
    //         // backgroundColor: "#FFF1F1",
    //         color: "primary.main",
    //         fontWeight: "bold",
    //         fontSize: "0.8rem",
    //       },

    //       "& .MuiDataGrid-columnHeader": {
    //         border: "none",
    //         // borderRight: "1px solid #C1C1C1",
    //       },
    //       "& .MuiDataGrid-columnHeader:last-of-type": {
    //         borderRight: "none",
    //       },

    //       "& .MuiDataGrid-cell": {
    //         border: "none",
    //         // borderRight: "1px solid #C1C1C1",
    //         color: "#333",
    //         fontWeight: 400,
    //         fontSize: "0.95rem",
    //       },
    //       "& .MuiDataGrid-cell:last-of-type": {
    //         borderRight: "none",
    //       },

    //       // ✨ Alternating row colors
    //       "& .MuiDataGrid-row:nth-of-type(even)": {
    //         backgroundColor: "#F9F9F9",
    //       },
    //       "& .MuiDataGrid-row:nth-of-type(odd)": {
    //         backgroundColor: "#FFF1F1",
    //       },
    //     },
    //   },
    //   defaultProps: {
    //     pageSizeOptions: [10, 25, 50, 100],
    //     initialState: {
    //       pagination: {
    //         paginationModel: { pageSize: 10, page: 0 },
    //       },
    //     },
    //     checkboxSelection: false,

    //   },
    // }


  },
});


export default theme;
